import { create } from 'zustand';

export const useExplicitConsentMethodStore = create((set) => ({
  // State
  methods: [],
  selectedMethod: null,
  loading: false,
  error: null,
  success: null,
  uniqueValues: {},
  paginationData: {
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  },

  // Table state
  searchParams: {
    searchTerm: '',
    sortBy: '',
    sortDirection: 'asc',
  },
  columnFilters: {},

  // Actions
  setMethods: (methods) => set({ methods }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setSuccess: (success) => set({ success }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),
  setPaginationData: (paginationData) => set({ paginationData }),

  setSearchTerm: (searchTerm) =>
    set((state) => ({
      searchParams: { ...state.searchParams, searchTerm, page: 1 }
    })),

  setSorting: (sortBy, sortDirection) =>
    set((state) => ({
      searchParams: { ...state.searchParams, sortBy, sortDirection, page: 1 }
    })),

  setColumnFilters: (columnFilters) => set({ columnFilters }),

  setCurrentPage: (page) =>
    set((state) => ({
      paginationData: { ...state.paginationData, currentPage: page }
    })),

  setPageSize: (pageSize) =>
    set((state) => ({
      paginationData: { ...state.paginationData, itemsPerPage: pageSize, currentPage: 1 }
    })),

  clearMessages: () => set({ error: null, success: null }),
  clearError: () => set({ error: null }),

  // Form State
  isFormOpen: false,
  isEditMode: false,
  formData: { name: '', description: '' },

  openForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    formData: { name: '', description: '' },
    error: null,
    success: null
  }),

  // Alias for compatibility
  openCreateForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    formData: { name: '', description: '' },
    error: null,
    success: null
  }),

  openEditForm: (method) => set({
    isFormOpen: true,
    isEditMode: true,
    formData: {
      name: method.name || method.method || '',
      description: method.description || ''
    },
    selectedMethod: method,
    error: null,
    success: null
  }),

  closeForm: () => set({
    isFormOpen: false,
    isEditMode: false,
    formData: { name: '', description: '' },
    selectedMethod: null,
    error: null,
    success: null
  }),

  // Delete Dialog State
  isDeleteDialogOpen: false,
  methodToDelete: null,

  openDeleteDialog: (method) => set({
    isDeleteDialogOpen: true,
    methodToDelete: method
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    methodToDelete: null
  }),





  // Reset
  reset: () => set({
    methods: [],
    loading: false,
    error: null,
    success: null,
    uniqueValues: {},
    paginationData: {
      currentPage: 1,
      totalPages: 0,
      totalItems: 0,
      itemsPerPage: 10,
      hasNextPage: false,
      hasPreviousPage: false,
    },
    searchParams: {
      searchTerm: '',
      sortBy: '',
      sortDirection: 'asc',
    },
    columnFilters: {}
  })
}));

export default useExplicitConsentMethodStore;
